import { createReducer } from "redux-create-reducer";

import {
  GET_ASYNC_JOBS,
  DELETE_ASYNC_JOB,
  GET_ASYNC_JOBS_COUNT,
  SET_ASYNC_JOBS_SEARCH_FILTERS,
  SET_ASYNC_JOBS_CURRENT_PAGE,
  DOWNLOAD_ASYNC_JOB_FILE,
  CLEAR_DOWNLOADED_ASYNC_FILE,
  SET_ASYNC_JOBS_ITEMS_PER_PAGE,
  SET_NO_ENTRIES_MESSAGE_ASYNC_JOBS,
} from "../types";

const initialState = {
  data: [],
  file: {},
  isLoading: false,
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  filters: {
    dateFrom: "",
    dateTo: "",
    jobType: "",
    jobResultType: "",
    finished: "",
  },
  noEntriesMessage: "",
};

const getAsyncJobsReducer = createReducer(initialState, {
  [GET_ASYNC_JOBS.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_ASYNC_JOBS.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_ASYNC_JOBS.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_ASYNC_JOBS.FULFILLED]: (state, { payload }) => {
    return {
      ...state,
      data: payload.data,
      isLoading: false,
    };
  },
  [DELETE_ASYNC_JOB.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [DELETE_ASYNC_JOB.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [DELETE_ASYNC_JOB.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [DELETE_ASYNC_JOB.FULFILLED]: (state, { payload, id }) => {
    return {
      ...state,
      data: state.data.filter((a) => a.id !== payload.data.id),
      isLoading: false,
    };
  },
  [SET_ASYNC_JOBS_SEARCH_FILTERS]: (state, { payload }) => ({
    ...initialState,
    clientTypes: state.clientTypes,
    filters: { ...state.filters, ...payload },
  }),
  [CLEAR_DOWNLOADED_ASYNC_FILE]: (state, { payload }) => ({
    ...state,
    file: {},
  }),

  [SET_ASYNC_JOBS_CURRENT_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [GET_ASYNC_JOBS_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_ASYNC_JOBS_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_ASYNC_JOBS_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_ASYNC_JOBS_COUNT.FULFILLED]: (state, { payload }) => {
    return {
      ...state,
      pageInfo: {
        ...state.pageInfo,
        count: payload.data,
      },
      isLoading: false,
    };
  },

  [DOWNLOAD_ASYNC_JOB_FILE.DEFAULT]: (state) => ({
    ...state,
  }),
  [DOWNLOAD_ASYNC_JOB_FILE.PENDING]: (state) => ({
    ...state,
  }),
  [DOWNLOAD_ASYNC_JOB_FILE.REJECTED]: (state) => ({
    ...state,
  }),
  [DOWNLOAD_ASYNC_JOB_FILE.FULFILLED]: (state, { payload }) => {
    const fileName = payload.headers["content-disposition"]
      .split("filename=")[1]
      .split(";")[0];
    return {
      ...state,
      file: { fileBytes: new Blob([payload.data]), fileName },
    };
  },
  [SET_ASYNC_JOBS_ITEMS_PER_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
  [SET_NO_ENTRIES_MESSAGE_ASYNC_JOBS]: (state, { payload }) => {
    return {
      ...state,
      noEntriesMessage: payload,
    };
  },
});

export default getAsyncJobsReducer;



// WEBPACK FOOTER //
// ./src/features/organization/reducers/getAsyncJobsReducer.js